// -----------------------------------------------------------------------------
// UTIL/DOM
// -----------------------------------------------------------------------------
// -----------------------------------------------------------------------------
export function input(type, className, placeholder) {
    const dom = document.createElement("input");
    dom.setAttribute("type", type);
    dom.setAttribute("class", className);
    if (placeholder) {
        dom.setAttribute("placeholder", placeholder);
    }
    return dom;
}
export function elt(type, props, ...children) {
    const dom = document.createElement(type);
    if (props !== null) {
        Object.assign(dom, props);
        for (let prop in props) {
            if (prop === "style") {
                dom.setAttribute("style", props[prop]);
            }
        }
    }
    for (let child of children) {
        if (typeof child !== "string") {
            dom.appendChild(child);
        }
        else {
            dom.appendChild(document.createTextNode(child));
        }
    }
    return dom;
}
export function setClass(dom, name, state) {
    if (state) {
        dom.classList.add(name);
    }
    else {
        dom.classList.remove(name);
    }
}
export function calcModulePosition(view, start, end, shim) {
    const container = view.dom.parentElement;
    const containerWidth = container.getBoundingClientRect().width;
    const a = view.coordsAtPos(start);
    const b = view.coordsAtPos(end);
    const rect = view.dom.getBoundingClientRect();
    const xOffset = -((containerWidth - rect.width) / 2) + rect.x;
    const yOffset = container.offsetTop;
    if (a.bottom === b.bottom) {
        return {
            x: ((b.left - a.left) / 2 + a.left) - xOffset - shim + "px",
            y: b.bottom + window.scrollY + 5 - yOffset + "px"
        };
    }
    else {
        return {
            x: b.left - xOffset - shim + "px",
            y: b.bottom + window.scrollY + 5 - yOffset + "px"
        };
    }
}
export function calcModulePosition_(view, panel, start, end, shim) {
    const container = view.dom.parentElement;
    const containerWidth = container.getBoundingClientRect().width;
    const a = view.coordsAtPos(start);
    const b = view.coordsAtPos(end);
    const rect = view.dom.getBoundingClientRect();
    const xOffset = -((containerWidth - rect.width) / 2) + rect.x;
    const yOffset = container.offsetTop;
    const scroll = panel ? panel.scrollTop : window.scrollY;
    if (a.bottom === b.bottom) {
        return {
            x: ((b.left - a.left) / 2 + a.left) - xOffset - shim + "px",
            y: b.bottom + scroll + 5 - yOffset + "px"
        };
    }
    else {
        return {
            x: b.left - xOffset - shim + "px",
            y: b.bottom + scroll + 5 - yOffset + "px"
        };
    }
}
